import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class TransloadOrders_ds_get_order_total_picked_units_by_orderIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shipmentIds?: number[] }): 
  Promise<{ result: { TotalUnitsPicked?: number, TotalOrderUnits?: number, ShipmentId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_get_order_total_picked_units_by_orderIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shipmentIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { TotalUnitsPicked?: number, TotalOrderUnits?: number, ShipmentId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_get_order_total_picked_units_by_orderIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shipmentIds?: number[], $keys: number[] }): 
  Promise<{ result: { TotalUnitsPicked?: number, TotalOrderUnits?: number, ShipmentId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_get_order_total_picked_units_by_orderIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shipmentIds?: number[]    }) {
      return false;
    }
}
